
export const useFilteredFormFields = (formData) => {
    const excludedFields = [
      'id',
      'steps',
      'password',
      'last_login',
      'is_superuser',
      'is_staff',
      'is_active',
      'date_joined',
      'role',
      'in_call',
      'user_permissions',
      'groups',
      'created_by',
      'gender',
      'postal_code',
      'image',
      'profile_score',
      'first_time'
    ];
  
    return Object.entries(formData).filter(
      ([key]) => !excludedFields.includes(key)
    );
  };